import { MAX_IMAGE_SIZE } from '@repo/types';
import axios from 'axios';

export function formatMaxImageSizeMb(maxBytes: number = MAX_IMAGE_SIZE): string {
  return `${Math.round(maxBytes / (1024 * 1024))} Mo`;
}

export function validateImageFile(file: File, maxSize: number = MAX_IMAGE_SIZE): string | null {
  if (!file.type.startsWith('image/')) {
    return 'Le fichier doit être une image (PNG, JPG, JPEG, WebP, etc.).';
  }
  if (file.size > maxSize) {
    return `Le fichier est trop volumineux. Taille maximale : ${formatMaxImageSizeMb(maxSize)}.`;
  }
  return null;
}

export function resolveUploadErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    if (error.code === 'ECONNABORTED') {
      return 'Le téléchargement a pris trop de temps. Réessayez avec une image plus légère ou une meilleure connexion.';
    }
    const apiMessage = error.response?.data?.message;
    if (typeof apiMessage === 'string' && apiMessage.length > 0) {
      return apiMessage;
    }
    if (error.response?.status === 413) {
      return 'Le fichier est trop volumineux pour le serveur.';
    }
    if (!error.response) {
      return 'Impossible de joindre le serveur. Vérifiez votre connexion.';
    }
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return 'Une erreur est survenue lors du téléchargement de l\'image.';
}
